import { StarFilled, StarOutlined } from '@ant-design/icons'
import { useBoolean } from 'ahooks'
import { createStyles } from 'antd-style'

import { collectListingApi } from '@eastcoal/api/trade/listingMall/collectListing'

import { ThrottleButton } from '@eastcoal/common/components/Button/ThrottleButton'

import { useCheckLogined } from '@eastcoal/auth/hooks/useCheckLogined'

import { ListingStarButtonProps } from './interface'

const useStyles = createStyles(({ token }) => ({
  icon: {
    fontSize: token.fontSizeXL
  }
}))

export const ListingStarButton = ({ data, type }: ListingStarButtonProps) => {
  const [isCollected, toggleCollected] = useBoolean(data?.collect)
  const validateLogin = useCheckLogined()

  const handleClick = async () => {
    if (!validateLogin()) {
      return
    }
    await collectListingApi({ id: data?.id })
    toggleCollected.toggle()
  }

  const { styles } = useStyles()

  return type === 'star' ? (
    <ThrottleButton type='link' onClick={handleClick}>
      {isCollected ? (
        <StarFilled className={styles.icon} />
      ) : (
        <StarOutlined className={styles.icon} />
      )}
    </ThrottleButton>
  ) : (
    <ThrottleButton ghost type='primary' onClick={handleClick}>
      {isCollected ? '取消收藏' : '加入收藏'}
    </ThrottleButton>
  )
}
